import { useSelector } from 'react-redux'

export default function useCurrentUserProp(propName) {
  return useSelector(({ auth: { user } }) => user?.[propName])
}
